__turbopack_context__.v({
  "editorWrapper": "RichTextAIField-module__86QlVq__editorWrapper",
  "fieldPadding": "RichTextAIField-module__86QlVq__fieldPadding",
  "fieldPaddingFocused": "RichTextAIField-module__86QlVq__fieldPaddingFocused",
  "fieldPaddingHover": "RichTextAIField-module__86QlVq__fieldPaddingHover",
  "label": "RichTextAIField-module__86QlVq__label",
  "labelRow": "RichTextAIField-module__86QlVq__labelRow",
  "optional": "RichTextAIField-module__86QlVq__optional",
  "required": "RichTextAIField-module__86QlVq__required",
  "root": "RichTextAIField-module__86QlVq__root",
});
